// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3Wqsx","content":"styles_content__XlWrb","selectAll":"styles_selectAll__3-9I2"};